import { Component, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CopyrightComponent } from '../copyright/copyright.component';

@Component({
  selector: 'lv-password-reset-request-sent',
  templateUrl: 'password-reset-request-sent.component.html',
  styleUrls: ['password-reset-request-sent.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule, TranslateModule, CopyrightComponent]
})
export class PasswordResetRequestSentComponent {}
